/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ covered: NonNullable<unknown>, total: NonNullable<unknown> }} Deep_Match_Keywords_CoveredInputs */

const en_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const de_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const fr_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const es_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const it_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const nl_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const pl_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const fi_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const da_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

const sv_deep_match_keywords_covered = /** @type {(inputs: Deep_Match_Keywords_CoveredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.covered} / ${i?.total} keywords covered`)
};

/**
* | output |
* | --- |
* | "{covered} / {total} keywords covered" |
*
* @param {Deep_Match_Keywords_CoveredInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_keywords_covered = /** @type {((inputs: Deep_Match_Keywords_CoveredInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Keywords_CoveredInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_keywords_covered(inputs)
	if (locale === "fr") return fr_deep_match_keywords_covered(inputs)
	if (locale === "es") return es_deep_match_keywords_covered(inputs)
	if (locale === "it") return it_deep_match_keywords_covered(inputs)
	if (locale === "nl") return nl_deep_match_keywords_covered(inputs)
	if (locale === "pl") return pl_deep_match_keywords_covered(inputs)
	if (locale === "fi") return fi_deep_match_keywords_covered(inputs)
	if (locale === "da") return da_deep_match_keywords_covered(inputs)
	if (locale === "sv") return sv_deep_match_keywords_covered(inputs)
	return en_deep_match_keywords_covered(inputs)
});